import { render } from "./ModalContent.vue?vue&type=template&id=8e40a674&scoped=true"
import script from "./ModalContent.vue?vue&type=script&lang=js"
export * from "./ModalContent.vue?vue&type=script&lang=js"

import "./ModalContent.vue?vue&type=style&index=0&id=8e40a674&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e40a674"]])

export default __exports__